import { PageHeaderModule } from 'Src/ng2/shared/components/header/page-header/page-header.module';
import { ContentToolsModule } from 'Src/ng2/shell/content-tools/content-tools.module';
import { FixedTableModule } from 'Src/ng2/shared/components/list/fixed-table/fixed-table.module';
import { FixedToInfiniteViewModule } from 'Src/ng2/shared/components/list/fixed-to-infinite-view-container/fixed-to-infinite-view.module';
import { ListContainerModule } from 'Src/ng2/shared/components/list/list-container/list-container.module';
import { NetworkStudentLevelDataService } from './network-student-level-data/network-student-level-data.service';
import { NetworkStudentLevelComponent } from './network-student-level.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [NetworkStudentLevelComponent],
  imports: [
    CommonModule,
    ListContainerModule,
    FixedToInfiniteViewModule,
    FixedTableModule,
    ContentToolsModule,
    PageHeaderModule,
  ],
  exports: [NetworkStudentLevelComponent],
  providers: [NetworkStudentLevelDataService],
})
export class NetworkStudentLevelModule {
  //
}
